module.exports = __webpack_public_path__ + "static/media/pattern.93775613.svg";